<script>
import TaskList from "@/components/Dashboard/Views/Dashboard/Widgets/TaskList.vue";
import {Badge} from "@/components/UIComponents";
import {Tooltip} from 'element-ui'
import swal from "sweetalert2";

export default {
  components: {
    Badge,
    [Tooltip.name]: Tooltip
  },
  name: 'ChangedPassword',
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    copyit() {
      let cb = document.getElementById("clipit");
      cb.style.display = 'block';
      cb.value = value;
      cb.select();
      document.execCommand('copy');
      cb.style.display = 'none';
      this.$toast.success(`${value} Copied!`)
    },
    deleteRow(row) {
      swal({
        title: this.$t('attentiontxt'),
        text: this.$t('confirmdelentry'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger btn-fill",
      })
        .then(() => {
          let success = resp => {
            if(resp.success) {
              this.$toast.success(this.$t("successtxt"))
              this.$refs.module.refreshList();
            } else {
              fail(resp)
            }

          }
          let fail = resp => {
            this.$toast.error(resp)
            console.log(resp)
          }

          this.$deleteChangelogPasswordEntry(row.id).then(success, fail)
      }).catch(swal.noop);
    },
    getFormattedDate(date){
      return this.$moment.utc(date).format("DD/MM/YYYY hh:mm:ss")
    }
  },
  mounted() {

  }

}
</script>

<template>
  <module
    ref="module"
    id="changed-password"
    title-icon="fa fa-lock"
    :title="$t('changedpassword')"
    :filters.sync="filters"
    api-url="ACCAPIURL_V4"
    url="/changelog/changedpass"
    >
    <template slot="filter-field">
      <fg-input v-model="filters.account" :label="$t('account')"></fg-input>
    </template>
    <template slot="table-columns">
      <el-table-column :label="$t('action')" width="120px" align="center">
        <template slot-scope="scope">
          <el-tooltip :content="`${$t('confirm_password_change')}`" placement="top">
            <p-button v-on:click="deleteRow(scope.row)" link type="success">
                <i class="fa fa-check"></i>
            </p-button>
          </el-tooltip>

          <el-tooltip :content="`${$t('copy_pass')}`" placement="top">
            <p-button v-on:click="$copyToClipboard(scope.row.password)" link type="default">
                <i class="fa fa-key"></i>
            </p-button>
          </el-tooltip>

        </template>
      </el-table-column>

      <el-table-column prop="userid" :label="$t('user')">
        <template slot-scope="scope">
          <span v-on:click="$copyToClipboard(scope.row.userid)" class="clickable">
            <strong> {{scope.row.userid}} </strong>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="account" :label="$t('account')">
        <template slot-scope="scope">
          <span v-on:click="$copyToClipboard(scope.row.account)" class="clickable">
            <strong> {{scope.row.account}} </strong>
          </span>
          &nbsp;
          <badge type="success" v-if="scope.row.type == 'master'">M</badge>
          <badge type="info" v-if="scope.row.type == 'follower'">F</badge>
        </template>
      </el-table-column>
      <el-table-column prop="strat_name" :label="$t('strategytxt')">
        <template slot-scope="scope">
          <strong> {{scope.row.strat_name}} </strong>
        </template>
      </el-table-column>
      <el-table-column prop="server" :label="$t('server')">
        <template slot-scope="scope">
          <span v-on:click="$copyToClipboard(scope.row.server)" class="clickable">
            <strong> {{scope.row.server}} </strong> ({{scope.row.platform}})
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="mat_server" :label="$t('mat')">
        <template slot-scope="scope">
          <span v-on:click="$copyToClipboard(scope.row.server)" class="clickable">
            <strong> {{scope.row.mat_server}} </strong>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="last_update" :label="$t('lastupdate')" align="center">
        <template slot-scope="scope">
         <strong> {{ getFormattedDate(scope.row.last_update) }} </strong>
        </template>
      </el-table-column>
    </template>

  </module>

</template>

<style scoped>

</style>
